import DeleteQuiz from "./DeleteQuiz";

export default DeleteQuiz